import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { BASE_URL } from "utils/constant";
import { useAlert } from "components/UI_components/Alert";

export default function AddVendor({ onClose }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [address, setAddress] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { addAlert } = useAlert();

  const handleNumberInput = (e) => {
    const onlyNums = e.target.value.replace(/[^0-9]/g, "");
    e.target.value = onlyNums;
    setContactNumber(onlyNums);
    if (onlyNums.length > 0 && onlyNums.length < 10) {
      setPhoneError("Contact number must be exactly 10 digits");
    } else {
      setPhoneError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    // 10-digit validation before API call
    if (contactNumber.length !== 10) {
      setPhoneError("Contact number must be exactly 10 digits");
      return;
    }
    setPhoneError("");

    try {
      setIsSubmitting(true);
      const accessToken = localStorage.getItem("access");
      const organisationId = JSON.parse(
        localStorage.getItem("organization"),
      ).id;
      const response = await fetch(`${BASE_URL}/inventory/create-vendor/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          name: name,
          vendor_type: type,
          address: address,
          contact_no: "+91" + contactNumber,
          organization: organisationId,
        }),
      });

      const data = await response.json();
      if (data.status) {
        console.log("Vendor created successfully:", data);
        onClose();
        addAlert("Vendor created successfully", "success");
      } else {
        console.error("Error creating vendor:", data.error);
        addAlert("Error creating vendor: " + data.error, "error");
      }
    } catch (error) {
      console.error("Error creating vendor:", error);
      addAlert("Error creating vendor: " + error.message, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-stretch justify-end z-50"
      onClick={onClose}
    >
      <div
        className="bg-white w-full sm:max-w-xl h-full flex flex-col rounded-l-xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-gray-200 py-4 px-6 sticky top-0 bg-white z-10 relative">
          <div className="text-center">
            <div className="text-[#232323] text-lg font-semibold">
              New Vendor
            </div>
            {/* <p className="text-xs text-gray-500 mt-0.5">
              Add vendor details for procurement and payments
            </p> */}
          </div>
          <button
            className="text-2xl font-semibold text-gray-500 hover:text-black absolute right-6 top-1/2 -translate-y-1/2"
            onClick={onClose}
          >
            <IoMdClose size={24} />
          </button>
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto px-6 py-5 pb-24">
          <div className="bg-white border border-gray-200 rounded-lg p-4 space-y-4">
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
              General Details
            </div>
            <div>
              <label className="block text-[#000000] text-[14px] font-medium mb-1.5">
                Vendor Name
              </label>
              <input
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Name"
                className="w-full h-9 px-3 rounded-md border border-gray-200 bg-white outline-none focus:ring-1 focus:ring-sm-primary"
              />
            </div>

            <div>
              <label className="block text-[#000000] text-[14px] font-medium mb-1.5">
                Select type
              </label>
              <input
                type="text"
                required
                value={type}
                onChange={(e) => setType(e.target.value)}
                placeholder="Enter Vendor type. (Eg. Brick supplier)"
                className="w-full h-9 px-3 rounded-md border border-gray-200 bg-white outline-none focus:ring-1 focus:ring-sm-primary"
              />
              <div className="mt-2 flex flex-wrap gap-2">
                {[
                  "Cement Supplier",
                  "Steel Supplier",
                  "Brick Supplier",
                  "Electricals",
                  "Plumbing",
                ].map((option) => (
                  <button
                    key={option}
                    onClick={() => setType(option)}
                    className={`px-3 py-1 rounded-full text-sm ${
                      type === option
                        ? "bg-[#ECE6F0] text-[#3B0069] border border-[#3B0069]"
                        : "bg-gray-100 border border-gray-200 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-[#000000] text-[14px] font-medium mb-1.5">
                Address
              </label>
              <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
                placeholder="Enter Address. (Saltlake, Kolkata, 700000)"
                className="w-full h-9 px-3 rounded-md border border-gray-200 bg-white outline-none focus:ring-1 focus:ring-sm-primary"
              />
            </div>

            <div>
              <label className="block text-[#000000] text-[14px] font-medium mb-1.5">
                Contact number <span className="text-red-500">*</span>
              </label>
              <div
                className={`flex items-center bg-white h-9 px-3 rounded-md border ${
                  phoneError ? "border-red-500" : "border-gray-200"
                }`}
              >
                <span className="mr-2 text-gray-600">+91</span>
                <input
                  type="text"
                  maxLength={10}
                  value={contactNumber}
                  onInput={handleNumberInput}
                  placeholder="9999999999"
                  required
                  className="w-full bg-transparent outline-none"
                />
              </div>
              {phoneError && (
                <p className="text-red-500 text-sm mt-1">{phoneError}</p>
              )}
            </div>
          </div>
        </div>

        <div className="p-3 bg-white border-t border-gray-200 flex justify-end gap-2 shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="px-4 h-9 text-sm font-medium border border-gray-300 rounded-md hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={
              isSubmitting ||
              !name.trim() ||
              !type.trim() ||
              !address.trim() ||
              contactNumber.length !== 10
            }
            className={`px-4 h-9 text-sm font-medium rounded-md transition-colors ${
              isSubmitting ||
              !name.trim() ||
              !type.trim() ||
              !address.trim() ||
              contactNumber.length !== 10
                ? "bg-gray-300 text-white cursor-not-allowed"
                : "bg-sm-primary text-white hover:bg-sm-hover"
            }`}
          >
            {isSubmitting ? "Creating..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
